import React from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

const NoteItem = ({ notes }) => {
  let history = useHistory();

  const URLImg = 'https://stucharge.bakersbrisk.com';
  function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  var bodyFormData = new FormData();
  const handleDelete = (key) => {
    const uname = JSON.parse(localStorage.getItem('uname'));
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const URL = `https://stucharge.bakersbrisk.com/api/notesapi?username=${uname}&id=${key}`;

    Swal.fire({
      title: 'Are you sure? Data will be deleted permanantly',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateClass();
      } else if (result.isDenied) {
        Swal.fire('Notes not deleted', '', 'info');
      }
    });

    async function updateClass() {
      bodyFormData.append('status', false);

      const requestOptions = {
        method: 'PUT',
        headers: { Authorization: AuthStr },
        body: bodyFormData,
      };
      fetch(URL, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          Swal.fire('Notes deleted successfully!', '', 'success').then(
            (result) => {
              if (result.isConfirmed || !result.isConfirmed) {
                history.push('/home');
                history.push('/notes');
              }
            }
          );
        })
        .catch((error) => {
          Swal.fire('Error deleting notes', '', 'error');
        });
    }
  };

  return (
    <>
      {notes.map((item) => (
        <tr key={item.id}>
          <td data-label='Title'>{jsUcfirst(item.title)}</td>
          <td data-label='Offer Price'>
            {item.offer_price === 0 ? 'Free' : `₹${item.offer_price}`}
          </td>
          <td data-label='Downloadable'>{item.downloadable ? 'Yes' : 'No'}</td>
          <td data-label='View'>
            <a
              href={URLImg + item.pdf}
              className='bttn view'
              target='_blank'
              rel='noreferrer noopene'
            >
              View
            </a>
          </td>
          <td data-label='Update'>
            <a
              href={`/notes/update/${item.id}`}
              className='bttn update'
              rel='noreferrer noopener'
            >
              Edit
            </a>
          </td>
          <td data-label='Delete'>
            <button
              href=''
              className='bttn delete'
              onClick={() => handleDelete(item.id)}
              rel='noreferrer noopener'
              style={{ cursor: 'pointer' }}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
    </>
  );
};

export default NoteItem;
